<template>
  <VanPopup
    v-model:show="store.showSelectMateModal"
    class="h-[60%] min-h-[10%] overflow-hidden"
    closeable
    position="bottom"
    round
  >
    <div class="grid grid-rows-[auto_auto_1fr] overflow-hidden h-full">
      <h2 class="text-center my-4 text-lg font-bold">
        {{ $t("game.base.selectCharacter") }}
      </h2>
      <VanTabs v-model:active="storyBookStore.role.tabType">
        <VanTab :title="$t('game.roleTab.my')" />
        <VanTab :title="$t('game.roleTab.myGuarded')" />
        <VanTab :title="$t('game.roleTab.guardians')" />
      </VanTabs>
      <div class="overflow-auto h-full">
        <div
          v-for="item in storyBookStore.canSelectStoreMateList"
          class="flex gap-4 my-3 px-3"
        >
          <div class="flex flex-col items-center">
            <UserAvatar
              :avatar-url="item?.mediaUrl"
              class="w-[100px] aspect-[3/4] mb-4"
            />
          </div>
          <div class="flex-1 flex flex-col">
            <div class="flex justify-between items-center mb-2">
              <div class="flex">
                <p class="mr-2">{{ item.name }}</p>
                <i
                  :class="[
                    'iconfont',
                    item.gender === 1 && 'icon-male text-[#5D9CEC]',
                    item.gender === 2 && 'icon-female text-[#EC4899]',
                  ]"
                ></i>
              </div>
              <button
                class="btn btn-xs px-6"
                @click="clickSelect(item as Mate)"
              >
                {{ t(`story.role.select`) }}
              </button>
            </div>
            <p class="text-xs">
              {{ item.bio }}
            </p>
          </div>
        </div>
        <div v-if="storyBookStore.canSelectStoreMateList.length === 0">
          <VanEmpty :description="$t('Message.noCharactersAvailable')" />
        </div>
      </div>
    </div>
  </VanPopup>
</template>

<script lang="ts" setup>
import { useAdmire } from "@/stores/admire";
import { useGalGameEditor } from "@/stores/galGameEditor";
import { useStoryBook } from "@/stores/story-book";
import { showLoadingToast } from "vant";
import { onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import i18n from "@/locales";

const { t } = useI18n();
const storyBookStore = useStoryBook();
const admireStore = useAdmire();
const store = useGalGameEditor();

const clickSelect = async (item: Mate) => {
  let character: GalGameCharacter = {
    mateId: item.id!,
    name: item.name,
    introduction: item.bio,
    avatarMediaId: item.mediaId,
    avatarMedia: {
      url: item.mediaUrl,
    } as Media,
    role: 2,
  };
  store.showSelectMateModal = false;
  store.characterIdMap[-1] = character;
  store.form.characterzz.push(character);
  const loading = showLoadingToast({
    message: i18n.global.t("Message.addingCharacter"),
  });
  const { characterzz } = await store.saveBase();
  characterzz.some((v: GalGameCharacter) => {
    if (v.mateId === item.id) {
      store.characterIdMap[v.id!] = {
        ...store.characterIdMap[-1],
        id: v.id,
      };
      const idx = store.form.characterzz.findIndex((v) => v.id === undefined);
      store.form.characterzz[idx].id = v.id;
      delete store.characterIdMap[-1];
      return true;
    }
  });
  loading.close();
  // 避免重复添加
  if (!storyBookStore.form.characterzz) storyBookStore.form.characterzz = [];
  storyBookStore.form.characterzz.push({ mateId: item.id! } as StoryCharacter);
};
onMounted(() => {
  admireStore.getAdmirerList();
  admireStore.getAdmiringList();
});
</script>
